<template>
  <section id="hero" class="w-full relative overflow-hidden">
    <!-- Hero container: vertical on mobile, grid on desktop -->
    <div class="flex flex-col lg:grid lg:grid-cols-2">
      <!-- LEFT: PAIN -->
      <div
        class="flex flex-col relative min-h-screen lg:h-screen justify-start lg:justify-center px-8 pt-12 lg:pt-0 text-white">
        <img
          :src="midJourneyImage"
          alt="frustrated entrepreneur"
          class="absolute inset-0 w-full h-full object-cover brightness-75" />
        <div class="absolute inset-0 bg-gradient-to-r from-[#221547cc] to-transparent"></div>

        <div class="relative z-10 space-y-6 text-center lg:text-left max-w-2xl mx-auto">
          <h1 class="text-5xl xl:text-6xl font-extrabold leading-tight">
            {{ $t("heroTotal.title") }}
          </h1>
          <p class="text-xl text-white/90">
            {{ $t("heroTotal.subtitle") }}
          </p>
          <ul class="text-lg space-y-2 text-left mx-auto lg:mx-0">
            <li>• {{ $t("heroTotal.pain1") }}</li>
            <li>• {{ $t("heroTotal.pain2") }}</li>
            <li>• {{ $t("heroTotal.pain3") }}</li>
          </ul>
          <p class="text-sm italic mb-12">
            {{ $t("heroTotal.supporting") }}
          </p>
        </div>
      </div>

      <!-- RIGHT: Deepen Problem Acknowledgment -->
      <div
        id="hero-solution"
        class="relative h-screen flex flex-col justify-center items-center text-white px-6 text-center">
        <img
          :src="painImage"
          alt="happy customer launching site"
          class="absolute inset-0 w-full h-full object-cover brightness-50" />
        <div class="absolute inset-0 bg-gradient-to-l from-white/20 via-white/10 to-transparent"></div>

        <div class="relative z-10 space-y-6 max-w-2xl mx-auto">
          <h2 class="text-3xl font-semibold">
            {{ $t("heroTotal.midJourneyTitle") }}
          </h2>
          <p class="text-lg text-gray-200">
            {{ $t("heroTotal.midJourneyIntro") }}
          </p>
          <p class="text-lg text-gray-200 font-medium">
            {{ $t("heroTotal.deepenProblem1") }}
          </p>
          <p class="text-xl text-white font-semibold italic">
            {{ $t("heroTotal.deepenProblem2") }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const painImage = "/images/visuals/pain.png";
const midJourneyImage = "/images/visuals/midJourney.webp";
</script>
